import { Commit } from 'vuex';

import { IState } from '@app/store/';
import OfferEvent from '@core/models/offer/OfferEvent';
import { RelativeRootGetters } from '@store/types';
import {
    filterResults,
    suggestionsFunction,
} from '@store/modules/ui/sportOffer/search/helpers';
import { SearchResultsTournament } from '@store/modules/ui/sportOffer/search/types';

export const saveQuery = 'SAVE_QUERY';
const numberOfSuggestions = 5;

export interface ISearchState {
    lastSearches: string[];
}

interface Getters {
    query: string;
    suggestions: (query: string) => string[];
}

const store = {
    namespaced: true,
    state: {
        lastSearches: [],
    },
    mutations: {
        [saveQuery](state: ISearchState, query: string) {
            if (state.lastSearches.indexOf(query) === -1) {
                state.lastSearches.push(query);
                if (state.lastSearches.length > numberOfSuggestions) {
                    state.lastSearches.shift();
                }
            }
        },
    },
    getters: {
        previousQueries(state: ISearchState) {
            return state.lastSearches;
        },
        query(state: ISearchState, getters: Getters, rootState: any, rootGetters: any): string {
            return rootGetters['navigation/route'].query.query || '';
        },
        results(state: ISearchState, getters: Getters, rootState: IState, rootGetters: RelativeRootGetters): {
            eventsByCompetitors: OfferEvent[];
            foundTournaments: SearchResultsTournament[]
        } {
            return filterResults(getters.query, rootGetters['data/sportOffer/eventsMap']);
        },
        suggestions(state: ISearchState, getters: Getters, rootState: IState, rootGetters: RelativeRootGetters): Getters['suggestions'] {
            return suggestionsFunction(rootGetters['data/sportOffer/events'], numberOfSuggestions);
        },
    },
    actions: {
        saveQuery: ({ commit }: { commit: Commit }, query: string) => {
            const sanitizedQuery = query.toLowerCase().trim();
            commit(saveQuery, sanitizedQuery);
        },
    },
};

export type SportOfferSearchStore = typeof store;

export default store;
